module.exports = __webpack_public_path__ + "static/img/advertisement2.5334dee3.png";